<template>
    <div @click="scrollToNextPosition()" class="scroller">
        <i class="fas fa-angle-double-down"></i>
    </div>
</template>

<script>
    export default {
        name: "ScrollDownComponent",
        data: function () {
            return {}
        },
        methods: {
            scrollToNextPosition() {
                $('html, body').animate(
                    {
                        scrollTop: $('#section-two-start').offset().top,
                    },
                    500,
                    'linear'
                )
            }
        }
    }
</script>

<style lang="scss" scoped>
    .scroller {
        height: 30px;
        width: 30px;
        line-height: 30px;
        font-size: 25px;
        text-align: center;
        position: absolute;
        bottom: 25px;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        cursor: pointer;
        color: #3a7bd5;

        animation: up_down 800ms infinite;
        animation-direction: alternate-reverse;

        &:hover {
             color: #6fa0d5;
         }
    }
    
    @media screen and (max-width: 768px) {
        .scroller {
            display: none;
        }
    }

    /*@keyframes up_down {*/
        /*0% {*/
            /*transform: translateY(0)*/
        /*}*/

        /*100% {*/
            /*transform: translateY(4px)*/
        /*}*/
    /*}*/
</style>